import { Component, EventEmitter, OnInit } from '@angular/core';
import { Configuration } from 'src/app/app.constants';
import { Employee } from 'src/app/modules/shared/models/employee';
import { AccountSettingsService } from 'src/app/modules/shared/services/account-settings.service';
import { AuthenticationService } from 'src/app/modules/shared/services/authentication.service';
import { CachingService } from 'src/app/modules/shared/services/caching.service';
import { AccountSelectItemViewModel } from 'src/app/modules/shared/viewModels/accountSelectItemViewModel';
import { JwtHelperService, JWT_OPTIONS  } from '@auth0/angular-jwt';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AuthService } from 'src/app/modules/auth/auth.service';
import { from } from 'rxjs';
@Component({
  selector: 'user-accounts',
  templateUrl: './user-accounts.component.html',
  styleUrls: ['user-accounts.component.scss'],
  providers: [
    { provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
    JwtHelperService
    ],
    standalone: false
})
export class UserAccountSelectComponent implements OnInit {
  public isLoading: boolean = true;
  public employee: Employee;
  public accounts: AccountSelectItemViewModel[] = [];
  public localUrl: string;
  accountSelected = new EventEmitter<AccountSelectItemViewModel>();
  constructor(
    private readonly configuration: Configuration,
    private readonly authenticationService: AuthenticationService,
    private readonly cachingService: CachingService,
    private readonly accountSettingsService: AccountSettingsService,
    private readonly jwtHelper: JwtHelperService,
    private readonly modalRef: BsModalRef,
    private readonly authService: AuthService
  ) { }
  ngOnInit() {
    this.localUrl = this.configuration.BackEndAPI;
    this.employee = undefined; //this.authenticationService.getCurrentEmployee();
    let employeeEmail = this.employee?.username;
    this.accounts = [];

    if (!employeeEmail) {
      from(this.authService.getBearerToken()).subscribe(token => {
        console.log(token);
        if (token) {
          var decoded = this.jwtHelper.decodeToken(token);
          console.log(decoded);
          if (decoded) {
            employeeEmail = decoded['email'];
          }
          console.log(employeeEmail);
          if(employeeEmail) {
            this.getApplicableAccounts(employeeEmail);
          }
        }
      })
    }

    this.isLoading = false;
  }

  getApplicableAccounts(employeeEmail: string): void {
    this.isLoading = true;
    this.accountSettingsService.getApplicableAccounts(employeeEmail).subscribe(res => {
      console.log(res);
      this.accounts = res;
      console.log(this.accounts);
      this.isLoading = false;
    })
  }

  onLoginWithAccount(account: AccountSelectItemViewModel) {
    if (!account.isActive) {
      return;
    }

    this.accountSelected.emit(account);
    this.modalRef.hide();

    // if (Capacitor.getPlatform() !== 'web' || this.configuration.configuration == 'development') {
    //   this.cachingService.setCurrentAccount(account);
    //   location.reload();
    // } else {
    //   document.location.href = account.url;
    // }
  }
}
